export var SessionUtilsShared;
(function (SessionUtilsShared) {
  function hasAuthInfo(state) {
    const hasInfo = !!(state && state.auth && state.auth.authType);
    return hasInfo;
  }
  SessionUtilsShared.hasAuthInfo = hasAuthInfo;
})(SessionUtilsShared || (SessionUtilsShared = {}));